import Name from './Name';
import NameOnBlur from './NameOnBlur';

export { Name, NameOnBlur };
